import { render, staticRenderFns } from "./BindingAccount.vue?vue&type=template&id=5f0e5854&"
import script from "./BindingAccount.vue?vue&type=script&lang=js&"
export * from "./BindingAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports